import { StaticContentContext } from '@/root/shared-providers'
import { useContext } from 'react'

export const useStaticContent = () => {
  return useContext(StaticContentContext)
}
